import React, { useState } from 'react';
import { COMMENT_CATEGORIES, RATING_LEVEL_LABELS } from 'src/models/reports';

interface CommentBankProps {
  id: string;
  selected: string[];
  onChange: (comments: string[]) => void;
}

export const CommentBank: React.FC<CommentBankProps> = ({ id, selected, onChange }) => {
  const [category, setCategory] = useState('learningBehaviours');
  const [rating, setRating] = useState('generally-positive');
  const toggle = (comment: string) => onChange(selected.includes(comment)
    ? selected.filter(item => item !== comment)
    : [...selected, comment]);

  return (
    <details className="report-notes__bank">
      <summary>
        <svg className="report-notes__bank-icon" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M9 18h6M10 22h4M12 2a7 7 0 0 0-4 12.7c.6.5 1 1.3 1 2.1V17h6v-.2c0-.8.4-1.6 1-2.1A7 7 0 0 0 12 2z" />
        </svg>
        <span className="report-notes__bank-text">
          Need ideas? Browse the comment bank <span>(optional{selected.length ? ` · ${selected.length} selected` : ''})</span>
        </span>
      </summary>
      <fieldset className="report-notes__radio-group">
        <legend>Area</legend>
        <div className="report-notes__radio-options">
          {Object.values(COMMENT_CATEGORIES).map(item => (
            <label key={item.id} className="report-notes__radio-option">
              <input type="radio" name={`${id}-category`} value={item.id} checked={category === item.id}
                onChange={() => setCategory(item.id)} />
              <span>{item.title}</span>
            </label>
          ))}
        </div>
      </fieldset>
      <fieldset className="report-notes__radio-group">
        <legend>Find ideas for</legend>
        <div className="report-notes__radio-options">
          {Object.entries(RATING_LEVEL_LABELS).map(([value, label]) => (
            <label key={value} className="report-notes__radio-option">
              <input type="radio" name={`${id}-rating`} value={value} checked={rating === value}
                onChange={() => setRating(value)} />
              <span>{label}</span>
            </label>
          ))}
        </div>
      </fieldset>
      <div className="report-notes__ideas">
        {COMMENT_CATEGORIES[category].ratingLevels[rating].map(comment => (
          <label key={comment} className="report-notes__idea">
            <input type="checkbox" checked={selected.includes(comment)} onChange={() => toggle(comment)} />
            <span>{comment}</span>
          </label>
        ))}
      </div>
      {selected.length > 0 && (
        <div className="report-notes__selected">
          <h4>Selected ideas ({selected.length})</h4>
          {selected.map(comment => (
            <div key={comment}>
              <span>{comment}</span>
              <button type="button" onClick={() => toggle(comment)} aria-label={`Remove idea: ${comment}`}>Remove</button>
            </div>
          ))}
        </div>
      )}
    </details>
  );
};
